import Faq from 'components/Common/Faq'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import Heading from 'LuxKit/Typography/Heading'
import React from 'react'

function LuxPlusMonthLandingPageFaq() {
  return <Sheet padding="64 0">
    <LayoutContainer variant="medium">
      <Group direction="vertical" gap={24}>
        <Heading variant="heading3" align="center" as="h2">Frequently Asked Questions</Heading>
        <Faq slug="luxplus-faqs" />
      </Group>
    </LayoutContainer>
  </Sheet>
}

export default LuxPlusMonthLandingPageFaq
